import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { CommunityNotificationSettingsDataObject } from 'models/service';

export type UpdateNotificationsSettingsRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  email_notifications_settings: {
    enable_notifications?: boolean;
    events?: boolean;
    giving?: boolean;
    newsfeed?: boolean;
    program?: boolean;
  };
  push_notifications_settings: {
    enable_notifications?: boolean;
    events?: boolean;
    giving?: boolean;
    newsfeed?: boolean;
    program?: boolean;
  };
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const updateNotificationsSettings = async ({
  data,
  id,
}: {
  data: UpdateNotificationsSettingsRequest;
  id: string;
}) =>
  apiClient.put<CommunityNotificationSettingsDataObject, ApiClientResponse<CommunityNotificationSettingsDataObject>>(
    routes.community.notifications.update(id),
    data,
  );
